module.exports = __webpack_public_path__ + "media/components/country-flag/static/ic-2593738eca5de0f0de7d548da9181bfd.svg";